import { useEffect, useState } from 'react'
import mapboxgl from 'mapbox-gl'
import {
  Map,
  useI18n,
  // useI18n,
  useMediaQuery,
  useRouter,
} from '@popety_io/popety-io-lib'
import { useSelector } from 'react-redux'
import { estimateSelector } from '../../../redux'
import { getPopulationTiles, removePopulationTiles } from './utils'

const fillStyle = 'layer_fill_population'

interface EstimatePopulationControllerProps {
  map: Map
  loaded?: boolean
}

const EstimatePopulationController = ({
  map,
  loaded,
}: EstimatePopulationControllerProps) => {
  const { t } = useI18n()
  const estimate: any = useSelector(estimateSelector)
  const { query } = useRouter()

  const [popup, setPopup] = useState<mapboxgl.Popup>()
  const isPopulationTab = query.subTab === 'population'
  const touchScreen = useMediaQuery('(hover: none)')

  useEffect(() => {
    if (touchScreen) setPopup(undefined)
  }, [touchScreen])

  useEffect(() => {
    setPopup(
      new mapboxgl.Popup({
        closeButton: false,
        closeOnClick: false,
      }),
    )
  }, [])

  useEffect(() => {
    if (query.subTab !== 'population' && map && loaded) {
      removePopulationTiles({ map })
    }
  }, [query.subTab, query.tab])

  const addTiles = () => {
    try {
      getPopulationTiles({
        map,
        fieldOpt: query.populationLayer,
      })
    } catch (e) {
      console.error(e)
    }
  }

  const handleMouseMove = (e: any) => {
    map.getCanvas().style.cursor = 'pointer'
    if (popup) {
      const feature = e?.features?.[0]

      if (!feature) return

      let str = `${t(`common.population.map.${feature.properties[query.populationLayer]}`)}`

      if (
        query.populationLayer === 'total_population' ||
        query.populationLayer === 'number_residents_city_0_1_year'
      ) {
        str = `${Math.round(feature.properties[query.populationLayer || 'total_population'])} ${t('common.personnes')}`
      }

      popup.setLngLat(e.lngLat).setHTML(str).addTo(map)
    }
  }

  const handleMouseLeave = () => {
    map.getCanvas().style.cursor = ''

    if (popup) {
      popup.remove()
    }
  }

  useEffect(() => {
    if (query.subTab !== 'population' || !map || !loaded) return

    addTiles()

    map.on('style.load', addTiles)
    map.on('mousemove', fillStyle, handleMouseMove)
    map.on('mouseleave', fillStyle, handleMouseLeave)

    return () => {
      map.off('style.load', addTiles)
      map.off('mousemove', fillStyle, handleMouseMove)
      map.off('mouseleave', fillStyle, handleMouseLeave)
    }
  }, [isPopulationTab, loaded, estimate, query.populationLayer])

  if (!isPopulationTab || !map || !loaded) return null

  return null
}

export default EstimatePopulationController
